import axios from './axios';


export default class CareerService{
    static async list(){
      return await axios.get("/career/list");
    };

    static async save(formData){
        return await axios.post("/career-application/save",formData);
    };
}